import qs from 'qs';
import { network } from 'services/network';

export const deleteStoredFilterBulkAssignOrRemoveTags = ({ id, contractId }) => {
    const querystring = qs.stringify({ id, contractId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/deleteStoredFilterBulkAssignOrRemoveTags${querystring}`;

    return network.get(url).then((response) => response.data);
};
